export type SkeletonAnimation =
  | 'fade' // simple crossfade
  | 'fade-up' // fade + slight up
  | 'fade-down' // fade + slight down
  | 'scale' // fade + subtle scale
  | 'slide-left' // horizontal slide
  | 'slide-right'
  /** For “chains” of ordered animations (stagger parent can control children) */
  | 'chain'

export const getMotionPreset = (animation: SkeletonAnimation = 'fade') => {
  switch (animation) {
    case 'fade-up':
      return {
        initial: { opacity: 0, y: 6 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -6 },
      }
    case 'fade-down':
      return {
        initial: { opacity: 0, y: -6 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 6 },
      }
    case 'scale':
      return {
        initial: { opacity: 0, scale: 0.985 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.985 },
      }
    case 'slide-left':
      return {
        initial: { opacity: 0, x: 10 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -10 },
      }
    case 'slide-right':
      return {
        initial: { opacity: 0, x: -10 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: 10 },
      }
    case 'chain':
      // “Chain”: no explicit initial/exit so the parent (stagger) can own timing.
      // Still safe defaults if rendered standalone.
      return {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.18 },
      }
    case 'fade':
    default:
      return {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      }
  }
}
